// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"f74015f4","906":"0465e893","948":"211d3956"}[chunkId] + ".chunk.css";
};